import { Trip } from "@fairfleet/geotab";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useFormattedDistance } from "@/hooks/metrics/useFormattedDistance";

export function DistanceCell(props: GridRenderCellParams<Trip>) {
  const formatted = useFormattedDistance(props.row.distance);

  return <>{formatted}</>;
}
